module.exports = __webpack_public_path__ + "static/media/plus-line.1e59e433.svg";